<script>
import { mapGetters } from 'vuex';
import PixiSmog from '@/components/pixi/PixiSmog';
import config from '@/config';
import TipsMsg from '@/components/ui/TipsMessage';
import TweenMax, { Power3, Expo } from 'gsap/TweenMax';

export default {
  name: 'Smog',
  components: {
    PixiSmog,
    TipsMsg
  },
  data() {
    return {
      trackName: 'smog-trame',
      leaving: false,
      gifURL: '/assets/transitions/mountroyal.gif',
    }
  },
  computed: {
    ...mapGetters({
      viewport: 'App/viewport',
      hasEnded: 'Sound/hasEnded',
      locale: 'I18n/locale',
    }),
    gifStyle() {
      return {
        backgroundImage: `url(${this.gifURL}`
      }
    },
  },
  watch: {
    viewport() {
      this.resize(this.viewport.width, this.viewport.height);
    },
  },
  mounted() {
    config.ga('pollution', this.locale);
    
    //preload future stuff
     if(!this.$store.getters['Preload/hasPreload']('Smog')) {
      this.$store.dispatch('Preload/START', "Smog");
    }
    
    this.$store.dispatch('Sound/FADE', {
      fromSound: this.trackName,
      volumeFrom: 0,
      volumeTo: config.SOUNDS[this.trackName].volume,
      duration: 2
    });

    //display bubble
    this.$store.dispatch('Interface/SHOW_BUBBLES');

    TweenMax.from(this.$el, 1, {alpha:0, ease:Power3.easeInOut, delay:.45});
  },
  methods: {
    resize(w, h) {
      this.$refs.pixi.resize(w, h);
    },

    onLeaving() {
      this.leaving = true;

      setTimeout( () => {
        this.$store.dispatch('Interface/HIDE_BUBBLES');
      }, 500);

      this.$store.dispatch('Sound/FADE', {
        fromSound: this.trackName,
        volumeTo: 0,
        duration: 1
      });

      TweenMax.from(this.$refs.Leaving, 1.5, {alpha:0, ease:Power3.easeInOut, onComplete: () => {
        
        this.$store.dispatch('Sound/PLAY', {id:'mountroyalS'});
        TweenMax.fromTo(this.$refs.Gif, 1, {display:'block', alpha:0}, {alpha:1, ease:Expo.easeInOut});   
        
        TweenMax.delayedCall(8.5, this.exit, null, this);
      }});
    },

    exit() {
      TweenMax.to(this.$el, 1, {alpha:0, ease:Power3.easeOut, onComplete: () => {

        TweenMax.delayedCall(.25, () => {
          this.$router.push({name:"Prelude", params: { id:"meteo" } });
        })

      }});
    },
  },
}
</script>

<template>
  <div class="Smog">
    <div class='gradient-bg'></div>
    <pixi-smog @leave="onLeaving" ref="pixi" />
    <tips-msg label-id="smog" />
    <div ref="Leaving" :class="['leaving-bg', {'-leaving': leaving}]"></div>
    <div ref="Gif" class="-GIF" :style="gifStyle" />
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Smog {
  position: relative;
  width: 100%;
  height: calc(100% - #{$header-height});
  margin: 0px;
  @include flexbox(center-vertical);

  @include ipad(landscape) {
    display: none;
  }
}

.gradient-bg, .leaving-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #858c7f 0%,#858c7f 50%,#5f635a 50%,#5f635a 100%);
  opacity: 1;
}

.leaving-bg {
  opacity: 1;
  display: none;
  background: linear-gradient(to bottom, $c-daintree 0%, $c-daintree 100%);

  &.-leaving {
    display: block;
  }
}

.-GIF {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display:none;
  background: {
    repeat: no-repeat;
    size: cover;
    position: center center;
  }
}

</style>
